import React from 'react'
import styled from 'react-emotion'

import { spacers } from '../theme'

const Wrapper = styled('footer')`
	font-size: 0.9rem;
	padding: ${spacers['6']} 0;
	text-align: center;
`

const Footer  = () => (
	<Wrapper>
		<p>365 Bloor Street East, Suite 902, Toronto, Ontario  M4W 3L4</p>
		<p>Phone: (416) 599-2458</p>
		<p><a href="https://www.cilt.ca/">CILT Official website</a></p>
	</Wrapper>
)

export default Footer
